import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import useApi from "../../../core/customhook/useApi";
import { useEffect, useState } from "react";

interface trainingData {
  training_type: string;
  training_name: string;
  training_date: string;
  training_time_from: string;
  training_time_to: string;
  description: string;
  status: string;
  delivery_plan_pnd_url: string;
  trainer_information: {
    name: string;
    experience_years: number;
    specialization: string;
    contact_email: string;
    phone: string;
  };
}
interface successResponse {
  success: boolean;
  message: string;
  statusCode: number;
  data: trainingData[];
}

const AllNominations = () => {
  const [selectedTrainer, setSelectedTrainer] = useState<any>(null);

  const routes = all_routes;
  const myData = [
    {
      start_date: "2025-06-01",
      end_date: "2025-06-03",
      training_timing: "10:00 AM - 4:00 PM",
      venue: "Mumbai, Maharashtra, India",
      delivery_plan_pnd_url: "https://example.com/delivery_plan_1.pdf",
      learning_outcoms_url: "https://example.com/delivery_plan_1.pdf",
      data_target: "Sales Training - Conversion Rate",
      target_audience: "Sales team, Managers, Executives",
      trainer_information: {
        name: "Ravi Kumar",
        experience_years: 5,
        specialization: "Sales & Marketing",
        contact_email: "ravi.kumar@example.com",
        phone: "+91 987 654 3210",
      },
      training_type: "Sales",
      training_name: "Sales Conversion Rate Training",
      status: "Completed",
    },
  ];

  const [trainingList, setTrainingList] = useState<trainingData[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [trainerInfo, setTrainerInfo] = useState<any>(null);
  const columns = [
    {
      title: "TrainingType",
      dataIndex: "training_type",
      render: (text: string) => <span>{text}</span>,
      sorter: (a: trainingData, b: trainingData) =>
        a.training_type.localeCompare(b.training_type),
    },
    {
      title: "TrainingName",
      dataIndex: "training_name",
      render: (text: string) => <Link to="#">{text}</Link>,
      sorter: (a: trainingData, b: trainingData) =>
        a.training_name.localeCompare(b.training_name),
    },
    {
      title: "StartDate",
      dataIndex: "start_date",
      render: (text: string) => <span>{text}</span>,
      sorter: (a: any, b: any) => a.start_date.localeCompare(b.start_date),
    },
    {
      title: "EndDate",
      dataIndex: "end_date",
      render: (text: string) => <span>{text}</span>,
      sorter: (a: any, b: any) => a.end_date.localeCompare(b.end_date),
    },
    {
      title: "TrainingTime",
      dataIndex: "training_timing",
      render: (_: any, record: any) => <span>{record.training_timing}</span>,
      sorter: (a: any, b: any) =>
        a.training_timing.localeCompare(b.training_timing),
    },
    {
      title: "TargetAudience",
      dataIndex: "target_audience",
      render: (text: string) => <span>{text}</span>,
      sorter: (a: any, b: any) =>
        a.target_audience.localeCompare(b.target_audience),
    },
    {
      title: "Venue",
      dataIndex: "venue",
      render: (text: string) => <span>{text}</span>,
      sorter: (a: any, b: any) => a.venue.localeCompare(b.venue),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string) => {
        let badgeClass = "badge-secondary";

        switch (text.toLowerCase()) {
          case "planned":
            badgeClass = "badge-warning";
            break;
          case "upcoming":
            badgeClass = "badge-info";
            break;
          case "completed":
            badgeClass = "badge-success";
            break;
          case "cancelled":
            badgeClass = "badge-danger";
            break;
          default:
            badgeClass = "badge-secondary";
        }

        return (
          <span
            className={`badge ${badgeClass} d-inline-flex align-items-center badge-xs`}
          >
            <i className="fa fa-circle me-1" />
            {text}
          </span>
        );
      },
      sorter: (a: trainingData, b: trainingData) =>
        a.status.localeCompare(b.status),
    },
    {
      title: "DeliveryPlan",
      dataIndex: "delivery_plan_pnd_url",
      render: (url: string) => (
        <div className="text-center">
          <a href={url} target="_blank" rel="noopener noreferrer">
            <i
              className="fa fa-file-pdf text-danger"
              style={{ fontSize: "18px" }}
            ></i>
          </a>
        </div>
      ),
    },
    {
      title: "Learningoutcoms",
      dataIndex: "learning_outcoms_url",
      render: (url: string) => (
        <div className="text-center">
          <a href={url} target="_blank" rel="noopener noreferrer">
            <i
              className="fa fa-file-pdf text-danger"
              style={{ fontSize: "18px" }}
            ></i>
          </a>
        </div>
      ),
    },
    {
      title: "Trainer Information",
      dataIndex: "trainer_information",
      render: (_: any, record: trainingData) => (
        <div className="text-center">
          <a
            role="button"
            title="View Trainer Info"
          >
            <i
              className="fa fa-eye text-primary"
              style={{ fontSize: "18px" }}
            ></i>
          </a>
        </div>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_: any, record: trainingData) => (
        <div className="text-center">
          <button
            className="btn btn-sm btn-outline-primary"
            title="Request for Training"
          >
            <i className="fa fa-hand-pointer" style={{ fontSize: "16px" }}></i>
          </button>
        </div>
      ),
    },
  ];



  const {
    data: response,
    loading: loading,
    error: error,
  } = useApi<successResponse>("/api/traning-schedule", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    if (response?.data) {
      setTrainingList(response.data);
    }
  }, [response]);

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Training Nominations</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Performance</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Training Nominations
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <Link
                  to="/training-calender"
                  className="btn btn-primary d-flex align-items-center"
                >
                  Training Calendar
                </Link>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Training Nominations List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Sort By : Last 7 Days
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Desending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table dataSource={myData} columns={columns} Selection={false} />
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>

      <div
        className="modal fade"
        id="trainerModal"
        aria-hidden="true"
        aria-labelledby="trainerModalLabel"
        tabIndex={-1}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="trainerModalLabel">
                Trainer Information
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              {selectedTrainer ? (
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">
                    <strong>Name:</strong> {selectedTrainer.name}
                  </li>
                  <li className="list-group-item">
                    <strong>Experience:</strong>{" "}
                    {selectedTrainer.experience_years} years
                  </li>
                  <li className="list-group-item">
                    <strong>Specialization:</strong>{" "}
                    {selectedTrainer.specialization}
                  </li>
                  <li className="list-group-item">
                    <strong>Email:</strong> {selectedTrainer.contact_email}
                  </li>
                  <li className="list-group-item">
                    <strong>Phone:</strong> {selectedTrainer.phone}
                  </li>
                </ul>
              ) : (
                <p>No trainer selected.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllNominations;
